import styles from './HandWrittenText.module.scss'

const HandWrittenText = ({ children, isSmall, width, fontSize, invisibleText }) => (
  <div
    className={`${invisibleText ? styles.invisibleText : ''}  ${styles.text} ${
      isSmall ? styles.isSmall : styles.isRegular
    }`}
    style={{ width, fontSize }}
  >
    {children}
  </div>
)

export default HandWrittenText
